import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {MultipleChipSelect} from '~/components/shared/MultipleChipSelect';
import {PAGE_URLS} from '~/constants';
import {
  NONE_VALUE,
  WEIGHT_LOSS_KEYS,
  WEIGHT_LOSS_ONE_QUESTIONNAIRES,
  WL_PROGRAMS,
} from '~/constants/medical-questionnaires';
import {useInput} from '~/hooks';
import {setNextQuestionnaire, setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const Questionnaire7Screen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.FOLLOWING_APPLY);

  const currentAnswer = useSelector(
    (state: RootState) => state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.FOLLOWING_APPLY]?.data,
  );

  const selectedProgram = useSelector(
    (state: RootState) =>
      state.questionnaires?.collectedData[WEIGHT_LOSS_KEYS.PROGRAM_SELECTION]?.data?.selectedProgramLocal,
  );

  const noneOption = questionnaire?.options?.find(i => i.value === NONE_VALUE);
  const selectOptions = questionnaire?.options?.filter(i => i.value !== NONE_VALUE) || [];

  const defaultOptions = selectOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    if (currentAnswer?.selectedOptions?.length) {
      currentAnswer?.selectedOptions.map((i: string) => {
        if (i !== NONE_VALUE) res[i] = true;
      });
    }

    return res;
  }, {});

  const resetSelectOptions = selectOptions.reduce<Record<string, boolean>>((res, cur) => {
    res[cur.value] = false;

    return res;
  }, {});

  const {inputs, setInputs, validation} = useInput({
    defaultOptions,
    noneOptionSelected:
      (currentAnswer?.selectedOptions?.length && currentAnswer?.selectedOptions[0] === NONE_VALUE) || false,
  });

  const onClickOption = (answer: {value: string | number; label: string}) => {
    const {value} = answer;
    setInputs({
      noneOptionSelected: false,
      defaultOptions: {...inputs.defaultOptions, [value]: !inputs.defaultOptions[value]},
    });
  };

  const onClickNoneOption = () => {
    setInputs({noneOptionSelected: !inputs.noneOptionSelected, defaultOptions: resetSelectOptions});
  };

  const dataSubmit = Object.keys(inputs.defaultOptions).filter(i => inputs.defaultOptions[i] === true);

  const collectedData = mdq.collectedData;

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.FOLLOWING_APPLY,
      index: questionnaire?.index || '',
      data: {selectedOptions: inputs?.noneOptionSelected ? [NONE_VALUE] : dataSubmit},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.FOLLOWING_APPLY]: answerData,
          },
        },
      }),
    );
    history.push(PAGE_URLS.MDQ1_DOCTOR_CONSULTATION);
  };

  return (
    <UiQuestionnaireLayout
      backIcon
      actions={questionnaire?.actions}
      disableNext={!dataSubmit.length && !inputs.noneOptionSelected}
      handleOnNext={onClickSubmit}
      checkoutStep={questionnaire?.checkoutStep}
      pageTitle={questionnaire?.title}
    >
      <Col textAlign="center" mt={20} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={9}>
          {questionnaire?.questions?.default}
        </UiText>
        <UiText color="liteOuter" fontSize="sm">
          {questionnaire?.questions?.description}
        </UiText>
        <MultipleChipSelect
          mt={16}
          pl={3}
          selectOptions={selectOptions}
          noneOption={noneOption}
          selectedOptions={inputs.defaultOptions}
          noneOptionSelected={inputs.noneOptionSelected}
          onClickOption={onClickOption}
          onClickNoneOption={onClickNoneOption}
          justifyContent="center"
          alignItems="center"
        />
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire7Screen;
